import { createComponent } from '@carvana/merch-components';
import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const Error = createComponent<OwnProps>('svg', {
  className: 'u:h-[205px] u:w-[161px]'
});

const ErrorIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <Error viewBox="0 0 161 205" aria-hidden="true" ref={ref} {...props}>
    <defs>
      <polygon
        id="path-1"
        points="0 -5.68434189e-14 26.9291372 -5.68434189e-14 26.9291372 30.5592779 0 30.5592779"
      />
      <polygon
        id="path-3"
        points="0 -5.68434189e-14 26.9291372 -5.68434189e-14 26.9291372 30.5592779 0 30.5592779"
      />
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Desktop" transform="translate(-214.000000, -216.000000)">
        <g id="Group-5" transform="translate(214.000000, 204.000000)">
          <g id="Group">
            <ellipse
              id="Oval-3"
              fill="#CFEAF2"
              cx="83"
              cy="210.3"
              rx="57.6"
              ry="6.3"
            />
            <rect
              id="Rectangle-7"
              stroke="#183558"
              strokeWidth="4.608"
              fill="#9DA5AD"
              x="65.504"
              y="173.904"
              width="33.192"
              height="31.392"
              rx="3.456"
            />
            <rect
              id="Stem-Shadow"
              fillOpacity="0.397927989"
              fill="#183558"
              x="66.8"
              y="180.6"
              width="30.6"
              height="9"
            />
            <path
              d="M47,205.8 L117.2,205.8"
              id="Bottom"
              stroke="#183558"
              strokeWidth="4.608"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              id="Stem"
              stroke="#183558"
              strokeWidth="4.608"
              x="65.504"
              y="182.904"
              width="33.192"
              height="22.392"
              rx="3.456"
            />
            <rect
              id="Rectangle-7"
              stroke="#183558"
              strokeWidth="8.208"
              fill="#FFFFFF"
              x="4.304"
              y="82.104"
              width="151.992"
              height="99.792"
              rx="5.4"
            />
            <g id="Shadows" transform="translate(1.000000, 79.400000)">
              <polygon
                id="Path-2"
                fillOpacity="0.114611639"
                fill="#9DA5AD"
                points="152.2 59.8 85.6 101.2 152.2 101.2"
              />
              <polygon
                id="Path-2"
                fillOpacity="0.114611639"
                fill="#9DA5AD"
                transform="translate(36.100000, 22.900000) scale(-1, -1) translate(-36.100000, -22.900000) "
                points="69.4 2.2 2.8 43.6 69.4 43.6"
              />
              <polygon
                id="Path-3"
                fillOpacity="0.201539855"
                fill="#D8D8D8"
                points="4.6 99.4 155.8 4 155.8 19.4416111 28.5600223 99.4"
              />
              <polygon
                id="Path-3"
                fillOpacity="0.201539855"
                fill="#D8D8D8"
                points="56.8 101.2 159.4 36.4 159.4 46.8886415 73.0585866 101.2"
              />
              <polygon
                id="Path-3"
                fillOpacity="0.201539855"
                fill="#D8D8D8"
                transform="translate(51.300000, 32.400000) scale(-1, -1) translate(-51.300000, -32.400000) "
                points="0 64.8 102.6 0 102.6 10.4886415 16.2585866 64.8"
              />
            </g>
            <rect
              id="Rectangle-7"
              stroke="#183558"
              strokeWidth="8.208"
              x="4.304"
              y="82.104"
              width="151.992"
              height="99.792"
              rx="5.4"
            />
            <g id="Face" transform="translate(36.200000, 101.400000)">
              <path
                d="M52.7850824,55.4482837 C52.8211699,55.4482837 52.8557011,55.4335872 52.88072,55.4075803 C52.931533,55.3547606 52.9299062,55.2707479 52.8770885,55.2199366 C50.4302076,52.8660158 48.1828971,51.7850496 46.0944915,51.7850496 C44.0060865,51.7850496 41.7587767,52.8660152 39.3118965,55.2199347 C39.2858893,55.2449538 39.2711926,55.2794855 39.2711926,55.3155733 C39.2711926,55.3888666 39.3306085,55.4482825 39.4039021,55.4482825 L52.7850827,55.4482837 Z"
                id="Path-4"
                stroke="#183558"
                strokeWidth="6.3700992"
              />
              <g id="Group-4">
                <g
                  id="Group-3"
                  transform="translate(18.861604, 17.745694) rotate(109.000000) translate(-18.861604, -17.745694) translate(5.361604, 2.445694)"
                >
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <g id="Clip-2" />
                  <path
                    d="M26.7467697,26.225765 C26.2822292,25.207478 25.0784662,24.7578215 24.0600355,25.2214154 C16.8259864,28.5041024 8.25863671,25.3005238 4.96658757,18.0784566 C2.65200087,12.9985452 4.91110491,6.98638489 10.0040384,4.6751116 C13.5052205,3.08476809 17.657524,4.63501237 19.2520847,8.13119863 C20.3113275,10.4570322 19.2770558,13.2090078 16.9479546,14.2656032 C15.4848043,14.9310948 13.7589113,14.2817208 13.0949922,12.8267024 C12.723391,12.0121818 13.0864084,11.0473864 13.9036656,10.6766826 C14.923891,10.2140231 15.3746974,9.01291466 14.9099228,7.99587344 C14.4465529,6.97665206 13.2416194,6.52863069 12.2231887,6.99152382 C9.37000665,8.28630092 8.10412803,11.655104 9.40114249,14.5019162 C10.9910991,17.9887589 15.1290442,19.5365895 18.6262465,17.9519299 C22.9928332,15.9710276 24.9305905,10.8137986 22.9456223,6.45567344 C20.4253361,0.927974198 13.868628,-1.52952504 8.3238737,0.990030687 C1.19470318,4.22467649 -1.96851069,12.6417788 1.2732841,19.7549162 C4.36603266,26.5420429 11.0947292,30.5592856 18.1208939,30.5592856 C20.6749691,30.5592856 23.2687639,30.0285742 25.7402003,28.9064963 C26.7595673,28.4439147 27.2103737,27.2440521 26.7467697,26.225765"
                    id="Fill-1"
                    fill="#183558"
                  />
                </g>
                <g
                  id="Group-3"
                  transform="translate(72.861604, 17.745694) rotate(109.000000) translate(-72.861604, -17.745694) translate(59.361604, 2.445694)"
                >
                  <mask id="mask-4" fill="white">
                    <use xlinkHref="#path-3" />
                  </mask>
                  <g id="Clip-2" />
                  <path
                    d="M26.7467697,26.225765 C26.2822292,25.207478 25.0784662,24.7578215 24.0600355,25.2214154 C16.8259864,28.5041024 8.25863671,25.3005238 4.96658757,18.0784566 C2.65200087,12.9985452 4.91110491,6.98638489 10.0040384,4.6751116 C13.5052205,3.08476809 17.657524,4.63501237 19.2520847,8.13119863 C20.3113275,10.4570322 19.2770558,13.2090078 16.9479546,14.2656032 C15.4848043,14.9310948 13.7589113,14.2817208 13.0949922,12.8267024 C12.723391,12.0121818 13.0864084,11.0473864 13.9036656,10.6766826 C14.923891,10.2140231 15.3746974,9.01291466 14.9099228,7.99587344 C14.4465529,6.97665206 13.2416194,6.52863069 12.2231887,6.99152382 C9.37000665,8.28630092 8.10412803,11.655104 9.40114249,14.5019162 C10.9910991,17.9887589 15.1290442,19.5365895 18.6262465,17.9519299 C22.9928332,15.9710276 24.9305905,10.8137986 22.9456223,6.45567344 C20.4253361,0.927974198 13.868628,-1.52952504 8.3238737,0.990030687 C1.19470318,4.22467649 -1.96851069,12.6417788 1.2732841,19.7549162 C4.36603266,26.5420429 11.0947292,30.5592856 18.1208939,30.5592856 C20.6749691,30.5592856 23.2687639,30.0285742 25.7402003,28.9064963 C26.7595673,28.4439147 27.2103737,27.2440521 26.7467697,26.225765"
                    id="Fill-1"
                    fill="#183558"
                  />
                </g>
              </g>
            </g>
            <g
              id="Punctuation"
              transform="translate(57.200000, 0.000000)"
              fill="#00AED9"
              fontFamily="BrandonText-Black, Brandon Text"
              fontWeight="700"
            >
              <text
                id="?"
                transform="translate(31.113176, 28.992404) rotate(10.000000) translate(-31.113176, -28.992404) "
                fontSize="32.805"
              >
                <tspan x="22.7150959" y="40.9924039">
                  ?
                </tspan>
              </text>
              <text
                id="!"
                transform="translate(10.500000, 23.100000) rotate(-15.000000) translate(-10.500000, -23.100000) "
                fontSize="32.4"
              >
                <tspan x="6.0288" y="35.6">
                  !
                </tspan>
              </text>
            </g>
            <g
              id="Rings"
              transform="translate(18.200000, 34.200000)"
              stroke="#CFEAF2"
              strokeWidth="3.6"
            >
              <ellipse
                id="Oval"
                transform="translate(65.700000, 18.900000) rotate(-19.000000) translate(-65.700000, -18.900000) "
                cx="65.7"
                cy="18.9"
                rx="44.1"
                ry="4.5"
              />
              <ellipse
                id="Oval"
                transform="translate(55.800000, 15.300000) scale(-1, 1) rotate(-10.000000) translate(-55.800000, -15.300000) "
                cx="55.8"
                cy="15.3"
                rx="55.8"
                ry="4.5"
              />
            </g>
            <g
              id="Left-Star"
              transform="translate(13.700000, 58.500000) rotate(45.000000) translate(-13.700000, -58.500000) translate(7.400000, 52.200000)"
              stroke="#00AED9"
              strokeWidth="4.42368"
            >
              <path d="M6.1875,0.5671875 L6.1875,5.04765625" id="Path-45" />
              <path
                d="M7.54726562,6.40742188 L12.0277344,6.40742188"
                id="Path-45"
              />
              <path
                d="M0.347265625,6.40742187 L4.82773438,6.40742187"
                id="Path-45"
              />
              <path d="M6.1875,7.7671875 L6.1875,12.2476563" id="Path-45" />
            </g>
            <g
              id="Right-Star"
              transform="translate(146.900000, 44.100000) rotate(45.000000) translate(-146.900000, -44.100000) translate(140.600000, 37.800000)"
              stroke="#00AED9"
              strokeWidth="4.42368"
            >
              <path d="M6.1875,0.5671875 L6.1875,5.04765625" id="Path-45" />
              <path
                d="M7.54726562,6.40742188 L12.0277344,6.40742188"
                id="Path-45"
              />
              <path
                d="M0.347265625,6.40742187 L4.82773438,6.40742187"
                id="Path-45"
              />
              <path d="M6.1875,7.7671875 L6.1875,12.2476563" id="Path-45" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Error>
));

export default ErrorIcon;
